<template>
  <ModalPlay
    size="lg"
    hide-header
    :no-close-on-esc="false"
    :no-close-on-backdrop="false"
    @close="close"
  >
    <div class="tw:my-8 tw:pe-2 tw:h-[70vh] tw:overflow-y-scroll tw:p-8">
      <!-- eslint-disable-next-line vue/no-v-text-v-html-on-component vue/no-v-html -->
      <p v-if="config.content" class="content" v-html="config.content" />
      <iframe v-if="config.embed_link" :src="config.embed_link" class="frame" />
    </div>

    <div class="tw:w-full tw:flex tw:justify-end">
      <ButtonPlayV2 :text="'Não mostrar novamente'" @click="dontShowAgain" />
    </div>
  </ModalPlay>
</template>

<script lang="ts">
import { defineComponent } from "vue";
import { useConfigStore } from "@/store/config.store";
import { useUserStore } from "@/store/user.store";
import { ModalPlay } from '@/components/atomic';

export default defineComponent({
  name: "MyModalComponent",
  components: { ModalPlay },
  props: {
    onClose: {
      type: [Function, Array],
      required: true,
    },
    onHidden: {
      type: [Function, Array],
      required: true,
    },
  },
  emits: ['close'],
  computed: {
    getSettings() {
      return useConfigStore().getSettings;
    },
    getUserMetas() {
      return useUserStore().getMetas;
    },

    config(): Record<string, unknown> {
      return JSON.parse(this.getSettings?.["first_access_config"] || "{}");
    },
  },
  methods: {
    actionSaveSiteMetas(payload: { key: string; value: unknown }) {
      return useUserStore().actionSaveSiteMetas(payload);
    },

    close(): void {
      this.$emit("close");
      const handlers = Array.isArray(this.onClose) ? this.onClose : [this.onClose];
      handlers.forEach((fn: unknown) => typeof fn === 'function' && fn());
    },

    hidden(): void {
      this.$emit("close");
      const handlers = Array.isArray(this.onHidden) ? this.onHidden : [this.onHidden];
      handlers.forEach((fn: unknown) => typeof fn === 'function' && fn());
    },

    async dontShowAgain(): Promise<void> {
      await this.actionSaveSiteMetas({
        key: "first_access_optout",
        value: "confirmed",
      });

      this.close()
    },
  },
});
</script>
